import { render, staticRenderFns } from "./AcceptDataPolicy.vue?vue&type=template&id=08e17402&"
import script from "./AcceptDataPolicy.vue?vue&type=script&lang=js&"
export * from "./AcceptDataPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports